import React, { useEffect, useContext, useState, useMemo, useCallback } from "react";
import { Modal, Button, Row, Col, Tabs, message, Dropdown, Menu, Breadcrumb, Tooltip } from "antd";
import ENVIRONMENT from "../../../../environments";
import GenerateAiVideoModal from "../GenerateAiVideoModal/GenerateAiVideoModal";
import FileConstants from "../../../../FileConstants";
import {
  getCollaborateImageFilepath,
  getCollaborationStatusTooltip,
  generateAndDownloadWatermarkedImage,
  saveToZip
} from "../../Utilities";
import axios from "axios";
import TwoDImagesContext from "../../ContextFiles/TwoDImagesContext";
import "./TwoDImages.scss";
import ProjectActionContext from "../../ContextFiles/ProjectActionContext";
import FlagSiloModal from "../ProductComponents/FlagSiloModal";
import GenerateHighResModal from "../CustomerProject/GenerateHighResModal";
import ComplaintModal from "../CustomerProject/ComplaintModal";
import TwoDImagesModal from "./TwoDImagesModal";
import ImageTabs from "./TabComponent";
import ImageOverlay from "./ImageOverlay";
import FavouriteIcon from "./FavouriteIcon";
import AIEditorModalViewer from "../AIEditorModalViewer/AIEditorModalViewer";
import { LoadingOutlined, ArrowLeftOutlined, DownloadOutlined, LinkOutlined, EditOutlined } from "@ant-design/icons";
import {
  DownOutlined,
  FlagOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  GET_IMAGES,
  PORTAL_LINK,
  WALMART_COMPANY_ID,
  getBaseURL,
  QA_IMG_URI,
  LOW_RES_QA_IMG_URI,
} from "../../../../environments/env";
import { saveAs } from "file-saver";

const CUSTOMER_USERNAME = localStorage.getItem("username");
const COMPANY_ID = localStorage.getItem('company_id')

const TwoDImagesTabs = () => {
  const {
    GetImageURL,
    Type,
    setImageType,
    images,
    resolution,
    formState,
    getResolutionCategory,
    markFavorite,
    unmarkFavorite,
    imagesInitialLoading,
    refetch,
    getTabResolution,
    tabResolutions,
    // AI Image Stack State Management
    stackState,
    stackImages,
    selectedStackParentId,
    enterStackState,
    leaveStackState,
    groupAIImagesByParent,
    // New image loader state
    showNewImageLoader,
    newImageSrc,
    // Prompts loading state
    promptsLoading,
    handleCollaborateAiImage,
    handleSubmitForReview
  } = useContext(TwoDImagesContext);
  const [singleImage, setSingleImage] = useState(true);
  const [selectedSiloImage, setSelectedSiloImage] = useState(null);
  const [imageFlagModal, setImageFlagModal] = useState(false);
  const [isModalVisible, setisModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [filteredImages, setFilteredImages] = useState([]);
  const [collaborationModal, setCollaborationModal] = useState();
  const [deleteModal, setDeleteModal] = useState();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [isCollaborationButtonLoading, setCollaborationButtonLoading] =
    useState(false);
  const [allImages, setAllImages] = useState(images);
  const [highResModalVisible, setHighResModalVisible] = useState(false);
  const [selectedLifestyleRender, setSelectedLifestyleRender] = useState(null);
  const [selectedSceneRenders, setSelectedSceneRenders] = useState([]);
  const [confirmHighResModal, setConfirmHighResModal] = useState(false);
  const [selectedImgComplaint, setSelectedImgComplaint] = useState(null);
  const [complaintModal, setComplaintModal] = useState(false);
  const [imgIndex, setImgIndex] = useState(-1);
  const [isAIModalOpen, setIsAIModalOpen] = useState(false);
  const [selectedAIImageData, setSelectedAIImageData] = useState(null);
  const [isGenVideoModalOpen, setIsGenVideoModalOpen] = useState(false);
  const [videoGenImage, setVideoGenImage] = useState(null);
  
  const handleOpenGenVideoModal = (image) => {
    setVideoGenImage(image);
    setIsGenVideoModalOpen(true);
  };
  const [compareSiloModalOpen, setCompareSiloModalOpen] = useState(false);
  const [imagesCount, setImagesCount] = useState({
    all: 0,
    silo: 0,
    lifestyle: 0,
    spin_360: 0,
    mp4: 0,
    favourites: 0,
    ai: 0,
    final_images: 0,
    ai_video: 0,
  });

  // Check if there are any final images
  const hasAnyFinalImages = useMemo(() => {
    return allImages && allImages.some(image => image.is_final_image === true);
  }, [allImages]);


  const [favouriteImages, setFavouriteImages] = useState([]);
  const [imageDisplayLoader, setImageDisplayLoader] = useState(false);

  // Get distinct usernames from AI images
  const distinctUsernames = useMemo(() => {
    if (!allImages) return [];
    const usernames = new Set();
    allImages.forEach((image) => {
      if (image && image.image_type === 'ai' && image.username) {
        usernames.add(image.username);
      }
    });
    console.log("@@@@@@@", usernames)
    return Array.from(usernames).sort();
  }, [allImages]);

  // // Convert Set to Array when rendering
  // const favouriteImagesArray = Array.from(favouriteImagesSet);

  // Add an image to the Set
  const addFavouriteImage = (image) => {
    setFavouriteImages((prevSet) => {
      const newSet = [...prevSet, image];
      return newSet;
    });
  };

  // Remove an image from the Set
  const removeFavouriteImage = (image) => {
    setFavouriteImages((prevSet) => {
      const newSet = prevSet.filter((item) => item !== image);
      return newSet;
    });
  };

  useEffect(() => {
    setAllImages(
      images?.map((image, index) => ({
        ...image,
        orignalIndex: index,
        src: GetImageURL(image),
        thumbnail:
          image.image_type == "lifestyle" || image.image_type == "silo" || image.image_type == "ai" || image.image_type == "ai_video"
            ? GetImageURL(image, true)
            : null,
      }))
    );
  }, [images]);

  useEffect(() => {
    // Set the favourite images as a Set of unique image sources (src)
    const favImages =
      allImages
        ?.filter((image) => image.src && image.isFavourite)
        .map((image) => image.src) || [];
    console.log("object fav:", favImages);
    setFavouriteImages(favImages);
  }, [allImages]);

  const getCollaborationDisplayName = (camera_name, display_name) => {
    let collab_display_name = display_name;
    if (!display_name) {
      collab_display_name =
        "Untitled " + camera_name.split(".")[0].split("_")[1];
    }
    return collab_display_name;
  };

  const updatedRenderNameInImagesList = (imageData, updatedDisplayName) => {
      let updatedList = allImages.map(item => {
        if(item.id == imageData.id){          
          if (item.image_type === "lifestyle" || item.image_type === 'ai' || item.image_type === 'ai_video') {
            // Update display_name
            // Preserve existing selectedAIImageData properties (like selectedImageUrl, renders, etc.) and only update display_name
            setSelectedAIImageData(prev => {
              if (prev && (prev.id === item.id || prev.render_id === item.id)) {
                return { ...prev, display_name: updatedDisplayName };
              }
              return { ...item, display_name: updatedDisplayName };
            });
            return { ...item, display_name: updatedDisplayName };

          } else if (item.image_type === "silo") {  
            // Update the camera_display_name
            // Preserve existing selectedAIImageData properties and only update camera_display_name
            setSelectedAIImageData(prev => {
              if (prev && (prev.id === item.id || prev.render_id === item.id)) {
                return { ...prev, camera_display_name: updatedDisplayName };
              }
              return { ...item, camera_display_name: updatedDisplayName };
            });
            return { ...item, camera_display_name: updatedDisplayName };
          }
          // If image_type doesn't match any handled type, return item unchanged
          return item;
        }
        else{
          return item;
        }
      })
      setAllImages(updatedList)
  }

  const collaborateConfirmModal = (
    camera_name,
    display_name,
    entity_id,
    collaboration_type,
    render_path = null
  ) => {
    let collaborationModalState = {
      camera_name: camera_name,
      display_name: getCollaborationDisplayName(camera_name, display_name),
    };
    if (collaboration_type == "lifestyle") {
      collaborationModalState["scene_id"] = entity_id;
    } else {
      collaborationModalState["product_id"] = entity_id;
      collaborationModalState["render_path"] = render_path;
    }
    setCollaborationModal(collaborationModalState);
  };

  const collaborateCloseConfirmModal = () => {
    setCollaborationModal(undefined);
    setCollaborationButtonLoading(false);
  };

  const createCollaborateEntity = () => {
    let payload = {
      ...collaborationModal,
      created_by: localStorage.getItem("username"),
      last_modified_by: localStorage.getItem("username"),
      state: {},
    };
    payload["is_msprovider"] = FileConstants.isMSProvider;

    axios
      .post(ENVIRONMENT.CREATE_COLLABORATE_ENTITY, payload)
      .then((res) => {
        if (res.data && res.data.body) {
          collaborateCloseConfirmModal();
          let collaboration_id = res.data.body.collaboration_entity_id;
          let url = "/collaborate-tool/" + collaboration_id;
          // if (projectId) {
          //   url = `${url}?origin=/projects/${projectId}&&project_id=${projectId}`;
          // }
          let new_window = window.open(url, "_blank");
          if (new_window) {
            new_window.focus();
          } else {
            window.location.href = url;
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        collaborateCloseConfirmModal();
      });
  };

  const openCollaborateTool = () => {
    setCollaborationButtonLoading(true);

    let payload = {
      ...collaborationModal,
    };
    if (payload["render_path"]) delete payload["render_path"];
    axios.post(ENVIRONMENT.GET_COLLABORATE_ENTITY, payload).then((res) => {
      console.log("res", res);
      if (res.data && res.data.length == 0) {
        createCollaborateEntity();
      } else {
        collaborateCloseConfirmModal();
        let collaboration_id = res.data.collaboration_entity_id;
        let url = "/collaborate-tool/" + collaboration_id;
        // if (projectId) {
        //   url = `${url}?origin=/projects/${projectId}&&project_id=${projectId}`;
        // }

        let new_window = window.open(url, "_blank");
        if (new_window) {
          new_window.focus();
        } else {
          window.location.href = url;
        }
      }
    });
  };

  const handleDeleteImage = (indexToDelete) => {
    // This removes a specific image at the given Index, from the allImages state
    setAllImages((prevImages) => {
      const updatedImages = [...prevImages];
      updatedImages.splice(indexToDelete, 1);
      return updatedImages;
    });
  };

  const deleteImage = () => {
    if (!deleteModal) return;

    setDeleteLoader(true);
    const companyId = localStorage.getItem("company_id");

    if (deleteModal.image_type === "lifestyle") {
      // delete lifestyle image
      let payload = {
        scene_id: deleteModal?.entity_id,
        username: localStorage.getItem("username"),
        camera_name: deleteModal?.filename,
      };

      let mapping_payload = {
        action: "hide_camera_scene_mapping",
        old_camera: deleteModal?.filename.split('.')[0],
        scene_id: deleteModal?.entity_id
      }

      axios.post(ENVIRONMENT.CAMERA_PRODUCT_MAP_CONTROLLER, mapping_payload)

      let collab_id = deleteModal['collaboration_id']
      if(collab_id){
        let collab_payload = {
            'is_hidden': true,
            'last_modified_by': localStorage.getItem('username'),
        }
        collab_payload['action'] = 'delete_collaboration';
        collab_payload['collaboration_id'] = collab_id;
        axios.post(ENVIRONMENT.COLLABORATION_ENTITY_UPDATE, collab_payload)
      }

      // Conditionally add companyId if it exists
      if (companyId) {
        payload.company_id = companyId;
      }

      axios
        .post(ENVIRONMENT.DELETE_LIFESTYLE, payload)
        .then((response) => {
          message.info("Image Deleted.");
          handleCancel(); // close the Modal
          if (imgIndex >= 0) {
            handleDeleteImage(imgIndex);
          }
        })
        .catch((error) => {
          message.error("Error in deleting Image");
        })
        .finally(() => {
          setDeleteModal(undefined);
          setDeleteLoader(false);
          setImgIndex(-1);
        });
    } else if (deleteModal.image_type === "silo") {
      // delete silo image
      let payload = {
        product_id: deleteModal?.entity_id,
        username: localStorage.getItem("username"),
        action: "delete",
        camera_name: deleteModal?.camera_name,
      };

      // Conditionally add companyId if it exists
      if (companyId) {
        payload.company_id = companyId;
      }

      axios
        .post(ENVIRONMENT.POST_PRODUCT_ASSET_UPDATE, payload)
        .then((response) => {
          message.info("Image Deleted.");
          handleCancel();
          if (imgIndex >= 0) {
            handleDeleteImage(imgIndex);
          }
        })
        .catch((error) => {
          message.error("Error in deleting Image");
        })
        .finally(() => {
          setDeleteModal(undefined);
          setDeleteLoader(false);
          setImgIndex(-1);
        });
    } else if (deleteModal.image_type === "ai" || deleteModal.image_type === "ai_video"){
      let payload = {
        action: deleteModal.image_type === "ai" ? "delete_ai_image" : "delete_ai_video",
        id: deleteModal.id,
      }

      axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload)
      .then((response) => {
        message.info(deleteModal.image_type === "ai" ? "Image Deleted." : "Video Deleted.");
        handleCancel();
        if (imgIndex >= 0) {
          handleDeleteImage(imgIndex);
        }
      })
      .catch((error) => {
        message.error(deleteModal.image_type === "ai" ? "Error in deleting Image" : "Error in deleting Video");
      })
      .finally(() => {
        setIsAIModalOpen(false);
        setDeleteModal(undefined);
        setDeleteLoader(false);
        setImgIndex(-1);
      });
    }
  };

  const handleDeleteClick = (image, imgIndex) => {
    setDeleteModal(image);
    if (imgIndex !== undefined && imgIndex !== null) {
      setImgIndex(imgIndex);
    }
  };

  const renderDelete = (x) => {

    if (
      !x ||
      (!x.filename && !x.camera_name && x.image_type !== 'ai' && x.image_type !== 'ai_video') ||
      x.image_type === "spin_360" ||
      x.image_type === "mp4"
    )
      return null;

    return (
      <Tooltip title={<span className="manrope f-12 white">Delete</span>}>
        <Button
          onClick={() => handleDeleteClick(x, x.index)}
          className="manrope f-14 w-500 lh-22 ai-action-btn ai-action-btn-red"
          icon={<DeleteOutlined />}
        />
      </Tooltip>
    );
  };

  const handleOpenHighResModal = (x) => {
    let render = { ...x };
    render["scene_id"] = x.entity_id;
    render["request_link"] = x.src;
    delete render.entity_id;
    if (x && x.filename) {
      setSelectedLifestyleRender(render);
      let final_renders = allImages
        .filter(
          (item) =>
            item.entity_id == x.entity_id && item.image_type == "lifestyle"
        )
        .map((item) => ({ ...item }));
      let flagged_images_camera_name = [];
      final_renders.map((render) => {
        if (render.complaint_id && render.complaint_status == "pending") {
          flagged_images_camera_name.push(render.filename);
        }
      });

      // remove the following keys from the final_renders dic, so that when updating the renders in DB we don't store useless info
      final_renders.forEach((obj) => {
        delete obj.collaboration_resolved;
        delete obj.collaboration_id;
        delete obj.annotation_count;
        delete obj.complaint_id;
        delete obj.complaint_status;
        delete obj.entity_id;
        delete obj.image_type;
        delete obj.entity_type;
      });
      setSelectedSceneRenders(final_renders);
      if (!flagged_images_camera_name.includes(x.filename)) {
        setHighResModalVisible(true);
      } else {
        // Complaint in progress, confirm if user want to generate a high Res.
        setConfirmHighResModal(true);
      }
    }
  };

  const renderGenerateHighResImage = (x) => {
    if (!x || !x.filename) return null;

    const isEditable =
      (x.collaboration_id && x.collaboration_resolved) ||
      x.collaboration_id === null;

    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <Tooltip
          title={
            <span className="manrope f-12 white">
              {!isEditable
                ? "Can't Generate high res image as a collaboration is in progress."
                : "Generate Any High Res Image"}
            </span>
          }
        >
          <span>
            <Button
              className="modal-okay square font-16 pd-6-14 h-40"
              onClick={() => handleOpenHighResModal(x)}
              disabled={!isEditable}
              style={{
                cursor: isEditable ? "pointer" : "not-allowed",
                marginLeft: 15,
              }}
              data-tut="reactour__stil_images_button"
            >
              <img
                src="/img/carbon_cloud-download.png"
                style={{ marginRight: 5 }}
              ></img>
              Generate Any High-Res Image
            </Button>
          </span>
        </Tooltip>
      </div>
    );
  };

  const openSingleFlagImage = (image) => {
    if (image.image_type === "silo") {
      setSingleImage(true);
      setSelectedSiloImage(image);
      setImageFlagModal(true);
    } else if (image.image_type === "lifestyle") {
      // open lifestyle image modal
      let selectedImg = { ...image };
      selectedImg["scene_id"] = image.entity_id;
      setSelectedImgComplaint(selectedImg);
      setComplaintModal(true);
      let lifestyle_renders = allImages.filter(
        (item) =>
          item.image_type === "lifestyle" && item.entity_id == image.entity_id
      );
      setSelectedSceneRenders(lifestyle_renders);
    }
  };

  const checkIfComplaintInProgress = (data) => {
    if (
      !data.complaint_status ||
      (data.complaint_status &&
        data.complaint_status != "rejected" &&
        data.complaint_status != "resolved")
    ) {
      return false;
    }
    return true;
  };

  const checkIfFlagIsDisabled = (x) => {
    if (FileConstants.isMSProvider) {
      if (x.flagged_by_user !== undefined) {
        return true;
      }
    } else if (x.flagged_by_user !== undefined) {
      if (x.generated_by_admin && x.captured_by != CUSTOMER_USERNAME) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleOk = () => {
    setisModalVisible(false);
  };

  const handleCancel = () => {
    setisModalVisible(false);
  };

  const renderReportButton = (x) => {
    if (x.image_type === "silo") {
      return (
        <span>
          <Button
            className="red-icon-button-container mr-8"
            onClick={() => openSingleFlagImage(x)}
          >
            <FlagOutlined />
          </Button>
        </span>
      );
    } else if (x.image_type === "lifestyle") {
      const isFlagDisabled =
        checkIfComplaintInProgress(x) || checkIfFlagIsDisabled(x);

      return (
        <Tooltip title={getTooltipTitle(x)}>
          <span>
            <Button
              className="red-icon-button-container mr-8"
              onClick={
                !checkIfFlagIsDisabled(x) || FileConstants.isMSProvider
                  ? () =>
                      checkIfComplaintInProgress(x)
                        ? ""
                        : checkIfFlagIsDisabled(x)
                        ? () => {}
                        : openSingleFlagImage(x)
                  : () => {}
              }
              disabled={isFlagDisabled}
            >
              <FlagOutlined />
            </Button>
          </span>
        </Tooltip>
      );
    }
  };

  const getTooltipTitle = (x) => {
    const isFlagDisabled = checkIfFlagIsDisabled(x);

    if (!isFlagDisabled || FileConstants.isMSProvider) {
      if (checkIfComplaintInProgress(x)) {
        return "You can't flag this image unless your complaint is resolved.";
      } else if (isFlagDisabled) {
        return "You cannot flag this image";
      }
    } else {
      return "You cannot flag more than once";
    }
  };

  const handleMarkFav = (obj) => {
    markFavorite(obj);
    addFavouriteImage(obj.src);
    
    // Optimistically update selectedAIImageData if this image is currently selected
    if (selectedAIImageData && (selectedAIImageData.id === obj.id || selectedAIImageData.render_id === obj.id)) {
      setSelectedAIImageData(prev => ({
        ...prev,
        isFavourite: true,
      }));
    }
  };

  const handleUnmarkFav = (obj) => {
    unmarkFavorite(obj);
    removeFavouriteImage(obj.src);
    
    // Optimistically update selectedAIImageData if this image is currently selected
    if (selectedAIImageData && (selectedAIImageData.id === obj.id || selectedAIImageData.render_id === obj.id)) {
      setSelectedAIImageData(prev => ({
        ...prev,
        isFavourite: false,
      }));
    }
  };

  function downloadFile(url, filename) {
    let loader = message.loading("Preparing to download..", 0);

    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        setTimeout(loader);

        var myBlob = this.response;
        saveAs(myBlob, filename);
      }
    };
    xhr.send();
  }

  const handleDownload = (src, obj) => {
    let downloadLink = src;
    let img_format = 'jpg'
    if (obj.filename) {
      img_format = obj.filename.split('.').pop()
    }
    else if (obj.image_type === 'ai_video') {
      img_format = downloadLink.split('.').pop()
    }
    else if (obj?.image_data?.img_format) {
      img_format = obj?.image_data?.img_format
    }

    if(img_format == 'tiff'){
      downloadLink = downloadLink.replace('.jpg', '.tiff')
    }
    if (downloadLink.includes(".tiff")) {
      downloadLink = downloadLink.replace(".jpg", ".tiff");
    }

    let display_name = obj.camera_display_name
      ? obj.camera_display_name
      : obj.display_name
      ? obj.display_name
      : "Untitled";
    if (img_format) {
      display_name = display_name + "." + img_format;
    }
    downloadFile(downloadLink, display_name);
  };

  const calculateCount = (array) => {
    // Initialize counts for each category
    const counts = array.reduce(
      (counts, image) => {
        if (image.image_type === "silo") counts.silo++;
        if (image.image_type === "lifestyle") counts.lifestyle++;
        if (image.image_type === "spin_360") counts.spin_360++;
        if (image.image_type === "mp4") counts.mp4++;
        if (image.image_type === "ai" && !image.is_final_image) counts.ai++;
        if (image.image_type === "ai_video") counts.ai_video++;
        if (image.isFavourite) counts.favourites++; // Count favourites if `isFavourite` is true
        if (image.is_final_image === true) counts.final_images++; // Count final images
        counts.all++; // Increment total count

        return counts;
      },
      {
        all: 0,
        silo: 0,
        lifestyle: 0,
        spin_360: 0,
        mp4: 0,
        favourites: 0,
        ai: 0,
        final_images: 0,
        ai_video: 0,
      }
    );

    // Set the state with the final counts
    setImagesCount(counts);
  };

  const renderFavouriteButton = (obj) => {
    if (obj.image_type === "ai") {
      return null;
    }
    return (
      <FavouriteIcon
        obj={obj}
        handleUnmarkFav={handleUnmarkFav}
        handleMarkFav={handleMarkFav}
        favouriteImages={favouriteImages}
      />
    );
  };

  const filterImages = useCallback((tabType = null, skipResolutionFilter = false) => {
    if (!allImages) return [];
    const array = allImages.map((obj, index) => {
      // Set width and height based on image type and frame resolution
      if (obj.image_type !== "spin_360") {
        obj.width_dim = (obj.width_dim) ? obj.width_dim : obj.width;
        obj.height_dim = (obj.height_dim) ? obj.height_dim : obj.height;
        obj.depth_dim = (obj.depth_dim) ? obj.depth_dim : obj?.depth || 0;
        
        if (obj.image_height > obj.image_width) {
          obj.width = 9;
          obj.height = 13;
        } else {
          obj.width = obj.image_width;
          obj.height = obj.image_height;
        }
      }

      if (obj.image_type === "mp4") {
        obj.mp4Preview =
          ENVIRONMENT.getBaseURL(obj.platform) +
          "product_assets/perspective_renders/" +
          obj.entity_id +
          "_HeadOn.jpg";
      }
      // Set display name if not defined
      obj.display_name =
        obj.display_name ||
        (obj?.filename
          ? `Untitled ${obj?.filename?.split(".")[0]?.split("_")[1]}`
          : `Untitled`);

      // Construct custom overlay
      obj.customOverlay = (
        <ImageOverlay
          stackState={stackState}
          obj={obj}
          imgIndex={index}
          unmarkFavorite={handleUnmarkFav}
          markFavorite={handleMarkFav}
          openSingleFlagImage={openSingleFlagImage}
          onCollaborate={collaborateConfirmModal}
          handleDownload={handleDownload}
          handleDeleteClick={handleDeleteClick}
          handleOpenHighResModal={handleOpenHighResModal}
          checkIfComplaintInProgress={checkIfComplaintInProgress}
          checkIfFlagIsDisabled={checkIfFlagIsDisabled}
          getTooltipTitle={getTooltipTitle}
          favouriteImages={favouriteImages}
          tab={tabType || Type}
          openGenVideoModal={handleOpenGenVideoModal}
        />
      );

      return obj;
    });
    
    const { startDate, endDate, searchTerm, types, project, engine, username, bulkRequestId } = formState;
    const currentTabType = tabType || Type;
    
    // For count calculation, use "all" resolution to get all images regardless of resolution
    // For display, use the specific tab's resolution
    const selectedResolution = skipResolutionFilter ? "all" : getTabResolution(currentTabType);

    // Convert startDate and endDate to timestamps (milliseconds since epoch)
    const startTimestamp = startDate ? new Date(startDate).getTime() : null;
    const endTimestamp = endDate ? new Date(endDate).getTime() : null;
    let result = array.filter((image, index) => {
      const resolutionMatches =
        selectedResolution === "all" ||
        selectedResolution === getResolutionCategory(image);

      const nameMatches = (image.camera_display_name || image.display_name)
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      
      // Check if search_keywords exist and match with searchTerm keywords
      const keywordMatches = (() => {
        if (!searchTerm || !searchTerm.trim()) return false;

        // Split searchTerm by spaces and filter out empty strings
        const searchKeywords = searchTerm.toLowerCase().split(/\s+/).filter(keyword => keyword.length > 0);

        // Check if image has search_keywords array
        if (!image.search_keywords || !Array.isArray(image.search_keywords)) {
          return false;
        }

        // Normalize search_keywords to lowercase strings for comparison
        const imageKeywords = image.search_keywords.map(kw => 
          typeof kw === 'string' ? kw.toLowerCase() : String(kw).toLowerCase()
        );

        // Check if any search keyword matches any image keyword
        return searchKeywords.some(searchKeyword => 
          imageKeywords.some(imageKeyword => imageKeyword.includes(searchKeyword) || searchKeyword.includes(imageKeyword))
        );
      })();

      const idMatches = String(image.entity_id) === String(searchTerm);

      // Check if time_updated lies within the selected date range
      const timeUpdated = image.time_updated;

      const dateMatches =
        startTimestamp !== null && endTimestamp !== null
          ? timeUpdated >= startTimestamp && timeUpdated <= endTimestamp
          : true; // Ignore date filtering if no start and end date are selected

      const typesMatch =
        types.length > 0
          ? types.includes(image.image_type) ||
            (types.includes("favourites") && image.isFavourite)
          : true;

      const isMp4VideoPending =
        image.image_type === "mp4" ? image.asset_status !== "pending" : true;

      const is360RenderComplete =
        image.image_type === "spin_360"
          ? image?.spin_360_details?.asset_status === "completed"
          : true;

      const projectInt =
        project && !Number.isInteger(project) ? parseInt(project, 10) : project;

      const projectFilter = projectInt
        ? image.project_ids?.includes(projectInt)
        : true;

      // Engine filter - only applies to AI images
      const engineFilter = engine
        ? image.image_type === "ai" && image.engine && image.engine.toLowerCase() === engine.toLowerCase()
        : true;

      // Username filter - only applies to AI images and only when on AI-related tabs (ai, final_images, or ai_video)
      const usernameFilter = (username && (currentTabType === "ai" || currentTabType === "final_images" || currentTabType === "ai_video"))
        ? (image.image_type === "ai" || image.image_type === "ai_video") && image.username && image.username === username
        : true;

      // Bulk request filter - only applies to AI images on Previews tab
      const bulkRequestFilter = (bulkRequestId && currentTabType === "ai")
        ? image.image_type === "ai" && image.bulk_request_id && String(image.bulk_request_id) === String(bulkRequestId)
        : true;

      if (
        (image.image_type === "silo" || image.image_type === "lifestyle") &&
        image.is_hidden
      ) {
        return false;
      }

      const aiImageStatus =
        (image.image_type === "ai" || image.image_type === "ai_video") ?
          (currentTabType === "ai") ?
            image.status === "completed" && !image.is_final_image :
          (currentTabType === "final_images") ?
            image.status === "completed" && image.is_final_image :
          (currentTabType === "ai_video") ?
            (image.status === "completed" || image.status === "inprogress") :
            image.status === "completed" :
          true;

      const imageStatusCheck =
        image.image_type === "silo" || image.image_type === "lifestyle"
          ? (image.status &&
              image.status !== "pending" &&
              image.status !== "hidden" &&
              image.status !== 'requested') ||
            (image.image_status && image.image_status !== "pending" && image.image_status !== "requested")
          : true;

      const complaintStatusCheck =
        image.image_type === "lifestyle"
          ? image.complaint_status !== "resolved"
          : true;
      const templateRenderCheck =
        image.image_type === "lifestyle" ? !image.template_render : true;

      // Apply tab-specific filtering
      const isFav =
        currentTabType === "favourites" &&
        (favouriteImages.length > 0
          ? favouriteImages.includes(image.src)
          : image.isFavourite);
      const isFinalImage = currentTabType === "final_images" && image.is_final_image === true;
      const typeFilter =
        currentTabType === "all" || isFav || isFinalImage ? true : image.image_type === currentTabType;

      return (
        imageStatusCheck &&
        image.filename !== "360Camera.jpg" &&
        resolutionMatches &&
        (nameMatches || keywordMatches || idMatches) &&
        dateMatches &&
        typesMatch &&
        isMp4VideoPending &&
        is360RenderComplete &&
        projectFilter &&
        engineFilter &&
        usernameFilter &&
        bulkRequestFilter &&
        complaintStatusCheck &&
        templateRenderCheck &&
        aiImageStatus &&
        typeFilter
      );
    });

    let final_images;
    
    // For favorites tab, show individual images without grouping
    if(currentTabType === 'favourites') {
      final_images = result;
    } else {
      final_images = groupAIImagesByParent(result);
    }
    
    if(currentTabType == 'final_images'){
      // Check if showNewImageLoader state exists and has a valid value
      if (showNewImageLoader && showNewImageLoader.trim() !== '') {
        let temp_obj = {
          display_name: "Untitled",
          entity_type: "product",
          image_type: "ai",
          is_final_image: true,
          orignalIndex: 0,
          src: newImageSrc || require("../../../../assets/images/scene_incomplete.svg"),
          status: "in-progress",
          thumbnail: newImageSrc || require("../../../../assets/images/scene_incomplete.svg"),
          uri: newImageSrc || require("../../../../assets/images/scene_incomplete.svg"),
        }

        temp_obj.customOverlay = (
          <ImageOverlay
            stackState={stackState}
            obj={temp_obj}
            imgIndex={0}
            unmarkFavorite={handleUnmarkFav}
            markFavorite={handleMarkFav}
            openSingleFlagImage={openSingleFlagImage}
            onCollaborate={collaborateConfirmModal}
            handleDownload={handleDownload}
            handleDeleteClick={handleDeleteClick}
            handleOpenHighResModal={handleOpenHighResModal}
            checkIfComplaintInProgress={checkIfComplaintInProgress}
            checkIfFlagIsDisabled={checkIfFlagIsDisabled}
            getTooltipTitle={getTooltipTitle}
            favouriteImages={favouriteImages}
            tab={currentTabType}
            openGenVideoModal={handleOpenGenVideoModal}
          />)

        final_images = [temp_obj, ...final_images]
      }
    }
    // Apply stacking logic to the filtered results
    return final_images
  }, [allImages, formState, Type, favouriteImages, getTabResolution, getResolutionCategory, groupAIImagesByParent, showNewImageLoader]);

  const imagesFiltered = useMemo(
    () => filterImages(),
    [filterImages]
  );

  // We calculate filtered images count for all tabs when top filter or search is applied, On resolution change we calculate count for current tab (performant)
  // Calculate base counts without resolution filters
  // Note: username filter is excluded from this effect - it only affects AI tab counts (handled separately below)
  useEffect(() => {
    if (allImages) {
      // Calculate counts based on filtered images (applying all filters except resolution and username)
      // We use 'all' tab type so username filter won't be applied (username filter only applies to 'ai' and 'final_images' tabs)
      const filteredImages = filterImages('all', true); // Skip resolution filter for counts
      
      // Extract individual images from stacks for accurate counting
      const individualImages = [];
      filteredImages.forEach(image => {
        if (image.image_type === "ai" && image.isStackDisplay && image.stackImages) {
          individualImages.push(...image.stackImages);
        } else {
          individualImages.push(image);
        }
      });
      
      calculateCount(individualImages);
    }
  }, [allImages, formState.startDate, formState.endDate, formState.searchTerm, formState.types, formState.project, formState.engine, favouriteImages, showNewImageLoader, filterImages]);

  // Separate effect to update AI and final_images counts when username filter changes
  // This ensures username filter only affects AI-related tabs, not other tabs
  useEffect(() => {
    if (allImages && (formState.username !== undefined)) {
      // Calculate AI counts with username filter applied
      const aiFilteredImages = filterImages('ai', true);
      const finalImagesFiltered = filterImages('final_images', true);
      const aiVideoFilteredImages = filterImages('ai_video', true);
      
      const aiIndividualImages = [];
      aiFilteredImages.forEach(image => {
        if (image.image_type === "ai" && image.isStackDisplay && image.stackImages) {
          aiIndividualImages.push(...image.stackImages);
        } else {
          aiIndividualImages.push(image);
        }
      });
      
      const finalIndividualImages = [];
      finalImagesFiltered.forEach(image => {
        if (image.image_type === "ai" && image.isStackDisplay && image.stackImages) {
          finalIndividualImages.push(...image.stackImages);
        } else {
          finalIndividualImages.push(image);
        }
      });

      const aiVideoIndividualImages = [];
      aiVideoFilteredImages.forEach(image => {
        if (image.image_type === "ai_video" && image.isStackDisplay && image.stackImages) {
          aiVideoIndividualImages.push(...image.stackImages);
        } else {
          aiVideoIndividualImages.push(image);
        }
      });
      
      // Update only AI, final_images, and ai_video counts
      setImagesCount(prevCounts => ({
        ...prevCounts,
        ai: aiIndividualImages.filter(img => img.image_type === "ai" && !img.is_final_image).length,
        final_images: finalIndividualImages.filter(img => img.is_final_image).length,
        ai_video: aiVideoIndividualImages.filter(img => img.image_type === "ai_video").length,
      }));
    }
  }, [formState.username, allImages, filterImages]);

  // Update count for current tab when resolution changes
  useEffect(() => {
    if (allImages && Type) {
      // Get filtered images for current tab with resolution filter applied
      const filteredImages = filterImages(Type, false); // Include resolution filter
      
      let currentTabCount = 0;
      
      if (Type === 'favourites') {
        // For favorites tab, filteredImages already contains individual images
        currentTabCount = filteredImages.length;
      } else {
        // For other tabs, extract individual images from stacks for accurate counting
        const individualImages = [];
        filteredImages.forEach(image => {
          if (image.image_type === "ai" && image.isStackDisplay && image.stackImages) {
            individualImages.push(...image.stackImages);
          } else {
            individualImages.push(image);
          }
        });

        // Calculate proper count for current tab based on image types
        individualImages.forEach(image => {
          switch (Type) {
            case "all":
              // Count all images (including final images)
              currentTabCount++;
              break;
            case "ai":
              if (image.image_type === "ai" && !image.is_final_image) currentTabCount++;
              break;
            case "final_images":
              if (image.is_final_image) currentTabCount++;
              break;
            case "silo":
              if (image.image_type === "silo") currentTabCount++;
              break;
            case "lifestyle":
              if (image.image_type === "lifestyle") currentTabCount++;
              break;
            case "spin_360":
              if (image.image_type === "spin_360") currentTabCount++;
              break;
            case "mp4":
              if (image.image_type === "mp4") currentTabCount++;
              break;
            case "ai_video":
              if (image.image_type === "ai_video") currentTabCount++;
              break;
          }
        });
      }
      
      // Update only the current tab's count
      setImagesCount(prevCounts => ({
        ...prevCounts,
        [Type]: currentTabCount
      }));
    }
  }, [Type, tabResolutions, allImages, formState.startDate, formState.endDate, formState.searchTerm, formState.types, formState.project, favouriteImages, showNewImageLoader, filterImages]);

  useEffect(() => {
    if (imagesFiltered) {
      const imagesWithIndex = imagesFiltered
        .map((image, index) => ({
          ...image,
          index,
        }));

      setFilteredImages([...imagesWithIndex]);
    }
  }, [imagesFiltered]);

  const showModal = useCallback((src) => {
    setSelectedImage(
      filteredImages.find((image) =>
        image.image_type == "mp4"
          ? image?.mp4Preview === src
          : image.image_type == "ai_video"
          ? image.thumbnail === src
          : image.src === src || image.thumbnail === src
      )
    );

    setisModalVisible(true);
    let index = allImages.findIndex((image) =>
      image.image_type == "mp4" 
        ? image?.mp4Preview === src 
        : image.image_type == "ai_video"
        ? image.thumbnail === src
        : image.src === src || image.thumbnail === src
    );
    setImgIndex(index);
  }, [filteredImages, allImages]);

  const handleAIImageClick = useCallback((imageData) => {
    const isVideo = imageData.image_type === 'ai_video';
    const baseUrl = ENVIRONMENT.getBaseURL(imageData.platform);
    const selectedUrl = isVideo ? baseUrl + imageData.uri : imageData.src.replace(LOW_RES_QA_IMG_URI, QA_IMG_URI).replace("_512.", ".");

    if(stackState && stackImages.length > 0){
      // We need to show the stacked images in carousal, set the selected accordingly
      let stackedRenders = []
      stackImages[0].stackImages.forEach((image, index) => {
        stackedRenders.push({
          ...image,
          uri: image.uri,
          render_id: image.id,
          renderIndex: index,
          display_name: image.display_name,
          prompt_text: image.prompt_text,
          isFavourite: image.isFavourite,
          favouriteId: image.favouriteId,
          input_image_uri: image.input_image_uri,
          inspiration_image_uri: image.inspiration_image_uri,
          src: image.src,
          flux_prompt: image.flux_prompt,
          image_width: image.image_width,
          image_height: image.image_height,
          resolution: image.resolution,
          asset_type: image.image_type === 'ai_video' ? 'ai_video' : 'ai_image'
        });
      });
      setSelectedAIImageData({
        ...imageData,
        selectedImageUrl: selectedUrl,
        renders: stackedRenders,
      });
      setIsAIModalOpen(true);
    }
    else{
      setSelectedAIImageData({
        ...imageData,
        selectedImageUrl: selectedUrl
      });
      setIsAIModalOpen(true);
    }
  }, [stackState, stackImages]);


  const handleAIModalClose = () => {
    setIsAIModalOpen(false);
    setSelectedAIImageData(null);
  };

  useEffect(() => {
    if (selectedAIImageData && allImages) {
      const imageId = selectedAIImageData.render_id || selectedAIImageData.id;
      const updatedImage = allImages.find(img => img.id === imageId);
      
      if (updatedImage) {
        setSelectedAIImageData(prev => ({
          ...prev,
          isFavourite: updatedImage.isFavourite,
          favouriteId: updatedImage.favouriteId,
          prompt_text: updatedImage.prompt_text,
          flux_prompt: updatedImage.flux_prompt,
          search_keywords: updatedImage.search_keywords,
        }));
        
        if (selectedAIImageData.renders && selectedAIImageData.renders.length > 0) {
          const updatedRenders = selectedAIImageData.renders.map(render => {
            const matchingImage = allImages.find(img => img.id === render.render_id);
            if (matchingImage) {
              return {
                ...render,
                isFavourite: matchingImage.isFavourite,
                favouriteId: matchingImage.favouriteId,
                prompt_text: matchingImage.prompt_text,
                flux_prompt: matchingImage.flux_prompt,
                search_keywords: matchingImage.search_keywords,
              };
            }
            return render;
          });
          
          setSelectedAIImageData(prev => ({
            ...prev,
            renders: updatedRenders,
          }));
        }
      }
    }
  }, [allImages, selectedAIImageData?.id, selectedAIImageData?.render_id]);

  const goToNextImage = () => {
    if (!selectedAIImageData || !selectedAIImageData.renders) return;
    
    setImageDisplayLoader(true);
    const currentIndex = selectedAIImageData.renderIndex || 0;
    const nextIndex = (currentIndex + 1) % selectedAIImageData.renders.length;
    const nextRender = selectedAIImageData.renders[nextIndex];
    let imageUrl = ENVIRONMENT.getBaseURL() + nextRender.uri;

    if (nextRender) {
        setSelectedAIImageData({
            ...selectedAIImageData,
            ...nextRender,
            selectedImageUrl: imageUrl,
            renderIndex: nextIndex,
            entity_id: nextRender.render_id || nextRender.id,
        });

        if (nextRender.asset_type !== 'ai_video' && nextRender.image_type !== 'ai_video') {
            const img = new Image();
            img.onload = () => {
                setImageDisplayLoader(false);
            }
            img.src = imageUrl;
        } else {
            setImageDisplayLoader(false);
        }
    }
};

const goToPreviousImage = () => {
    if (!selectedAIImageData || !selectedAIImageData.renders) return;
    
    setImageDisplayLoader(true);
    const currentIndex = selectedAIImageData.renderIndex || 0;
    const prevIndex = (currentIndex - 1 + selectedAIImageData.renders.length) % selectedAIImageData.renders.length;
    const prevRender = selectedAIImageData.renders[prevIndex];
    let imageUrl = ENVIRONMENT.getBaseURL() + prevRender.uri;

    if (prevRender) {
        setSelectedAIImageData({
            ...selectedAIImageData,
            ...prevRender,
            selectedImageUrl: imageUrl,
            renderIndex: prevIndex,
            entity_id: prevRender.render_id || prevRender.id,
        });

        if (prevRender.asset_type !== 'ai_video' && prevRender.image_type !== 'ai_video') {
            const img = new Image();
            img.onload = () => {
                setImageDisplayLoader(false);
            }
            img.src = imageUrl;
        } else {
            setImageDisplayLoader(false);
        }
    }
};

  const handleCollaborate = (obj) => {
    let displayName = "";

    let cameraName = null;
    let entityId = "";
    let renderPath = "";
    const base_url = getBaseURL(obj.platform);

    if (obj.image_type === "lifestyle") {
      entityId = obj.entity_id;
      cameraName = obj.filename;
      displayName = obj.display_name;
    } else {
      entityId = obj.entity_id;
      cameraName = obj.camera_name + "." + obj?.image_data.img_format;
      displayName = obj.camera_display_name;
      renderPath = obj.src.split(base_url)[1];
    }

    collaborateConfirmModal(
      cameraName,
      displayName,
      entityId,
      obj.image_type,
      renderPath
    );
  };

  const openAiImageEditor = (obj) => {
    const imageUrl = ENVIRONMENT.getBaseURL() + obj.uri;
    const productId = obj.entity_id;
    const promptText = encodeURIComponent(obj.flux_prompt || obj.prompt_text);
    window.location.href = `/edit-ai-image?imageUrl=${imageUrl}&imageId=${obj.id}&productId=${productId}&promptText=${promptText}`;
  }

  const downloadAiImagesVersions = (stackImages) => {
    console.log("****", stackImages)
    let imageUrls = [];
    let customNames = [];
    stackImages.forEach((image, index) => {
      imageUrls.push(ENVIRONMENT.getBaseURL() + image.uri);
      customNames.push('Image ' + (index + 1) + '.' + image.uri.split('.').pop());
    });
    saveToZip(`${stackImages[0].entity_id}_Ai_Images_Versions.zip`, imageUrls, true, customNames);
  }

  const renderCollaborationTooltip = (image) => {
    if (
      image.image_type === "spin_360" ||
      image.image_type === "mp4" ||
      image.image_type === "ai"
    ) {
      return null;
    }

    return (
      <Tooltip
        title={
          <span
            className="manrope f-12 white"
            dangerouslySetInnerHTML={{
              __html: getCollaborationStatusTooltip(image),
            }}
          ></span>
        }
      >
        <div
          className={`lifestyle-image-collaborate-icon ${
            image.white_balanced_image != undefined ? `` : `right`
          } ${
            image.collaboration_resolved
              ? "green"
              : image.collaboration_id == undefined
              ? "white border"
              : ""
          }`}
          onClick={() => handleCollaborate(image)}
        >
          <img
            className="collaborate-img"
            src={getCollaborateImageFilepath(image)}
            alt="Collaboration Icon"
          />
          <span
            className={`manrope f-14 w-500 ${
              image.collaboration_resolved ||
              image.collaboration_id != undefined
                ? "text-white"
                : ""
            }`}
          >
            Collaborate
          </span>
        </div>
      </Tooltip>
    );
  };

  const renderDownload = (src, obj) => {
    if (obj.image_type === "silo" || (COMPANY_ID != WALMART_COMPANY_ID && obj.image_type === "lifestyle")) {
      return (
        <span>
          <Button
            className="modal-okay square font-16 h-40 "
            data-tut="reactour__stil_images_button"
            onClick={() => handleDownload(src, obj)}
          >
            Download
          </Button>
        </span>
      );
    }
    else if(COMPANY_ID == WALMART_COMPANY_ID && obj.image_type === "lifestyle"){
      let downloadLink = src;
      
      let img_format = obj.filename.split('.').pop()
      if(img_format == 'tiff'){
        downloadLink = downloadLink.replace('.jpg', '.tiff')
      }

      let display_name = obj.camera_display_name
        ? obj.camera_display_name
        : obj.display_name
        ? obj.display_name
        : "Untitled";
      if(img_format){
        display_name = display_name + '.' + img_format
      }
      return (<Dropdown overlay={(<Menu style={{ width: "165px" }}>
        <Menu.Item key={1}>
            <a className='manrope f-12' target="_blank" onClick={() => handleDownload(src, obj)}> This Image </a>
        </Menu.Item>
        <Menu.Item key={2}>
            <a className='manrope f-12' target="_blank" onClick={() => generateAndDownloadWatermarkedImage(downloadLink, display_name)}>
              Watermarked Image 
            </a>
        </Menu.Item>

        </Menu>)} trigger={['click']}>
            <Button
                className="modal-okay square font-16 h-40 "
                data-tut="reactour__stil_images_button"
            >
                Download
                <DownOutlined />
            </Button>
        </Dropdown>)
    }
  };

  return (
    <Row>
      <Col span={24}>
        {stackState ? (
          // Render stack images when in stack state - clean minimal interface
          <div className="stack-images-container">
            <div style={{ marginBottom: '16px', marginLeft: '20px', marginRight: '20px', marginTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Breadcrumb>
                <Breadcrumb.Item className="manrope f-14 lh-28 black-73 white-space-text">
                  <a
                    className="manrope f-14 lh-28 black-73 white-space-text"
                    onClick={leaveStackState}
                    style={{ cursor: 'pointer' }}
                  >
                    <ArrowLeftOutlined className='mr-8'/>
                    Images
                  </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item className="manrope f-14 lh-28 black-55 ">
                  Edited Versions
                </Breadcrumb.Item>
              </Breadcrumb>
              
              {/* Action buttons */}
              <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                  onClick={() => downloadAiImagesVersions(stackImages)}
                  icon={<DownloadOutlined />}
                  style={{
                    border: '1px solid #E2E2E2',
                    borderRadius: '4px',
                    background: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px'
                  }}
                  title="Download"
                />
                <Button
                  icon={<LinkOutlined />}
                  style={{
                    border: '1px solid #E2E2E2',
                    borderRadius: '4px',
                    background: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px'
                  }}
                  title="Link"
                />
                <Button
                  onClick={() => openAiImageEditor(stackImages[0])}
                  icon={<EditOutlined />}
                  style={{
                    border: 'none',
                    borderRadius: '4px',
                    background: 'black',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 16px',
                    height: '40px'
                  }}
                >
                  Open Image Editor
                </Button>
              </div>
            </div>
            <div style={{ padding: '0 20px' }}>
              <ImageTabs
                distinctUsernames={distinctUsernames}
                filteredImages={stackImages.map((image, index) => {
                  // Process stack images the same way as normal images to get customOverlay
                  const processedImage = {
                    ...image,
                    orignalIndex: index,
                    src: GetImageURL(image),
                    thumbnail: GetImageURL(image, true),
                    width: image.image_width,
                    height: image.image_height,
                    display_name: image.display_name || `Untitled ${image?.filename?.split(".")[0]?.split("_")[1] || ''}`,
                  };
                  
                  // Add customOverlay for dropdown and favorite icons
                  processedImage.customOverlay = (
                    <ImageOverlay
                      stackState={stackState}
                      obj={processedImage}
                      imgIndex={index}
                      unmarkFavorite={handleUnmarkFav}
                      markFavorite={handleMarkFav}
                      openSingleFlagImage={openSingleFlagImage}
                      onCollaborate={collaborateConfirmModal}
                      handleDownload={handleDownload}
                      handleDeleteClick={handleDeleteClick}
                      handleOpenHighResModal={handleOpenHighResModal}
                      checkIfComplaintInProgress={checkIfComplaintInProgress}
                      checkIfFlagIsDisabled={checkIfFlagIsDisabled}
                      getTooltipTitle={getTooltipTitle}
                      favouriteImages={favouriteImages}
                      tab={Type}
                      openGenVideoModal={handleOpenGenVideoModal}
                    />
                  );
                  
                  return processedImage;
                })}
                imagesInitialLoading={false}
                showModal={showModal}
                setImageType={setImageType}
                Type={Type}
                imagesCount={{ ai: stackImages.length }}
                hasAnyFinalImages={true}
                onAIImageClick={handleAIImageClick}
                hideTabs={true}
                hideHeader={true}
                hideSearch={true}
                hideRadioButtons={true}
              />
            </div>
          </div>
        ) : (
          // Render normal images when not in stack state
          <ImageTabs
            filteredImages={filteredImages}
            imagesInitialLoading={imagesInitialLoading}
            showModal={showModal}
            setImageType={setImageType}
            Type={Type}
            imagesCount={imagesCount}
            hasAnyFinalImages={hasAnyFinalImages}
            onAIImageClick={handleAIImageClick}
            distinctUsernames={distinctUsernames}
          />
        )}
        {selectedSiloImage && (
          <ProjectActionContext.Provider
            value={{
              context_type: "project",
              product_id: selectedSiloImage?.entity_id,
              companyId: selectedSiloImage.company_id,
              imageFlagModal: imageFlagModal,
              selectedImageForFlag: selectedSiloImage.src,
              setImageFlagModal: setImageFlagModal,
              cognito_username: selectedSiloImage.captured_by,
              setSingleImage: setSingleImage,
              singleImage: singleImage,
              silos: filteredImages?.filter(
                (image) =>
                  image.image_type === "silo" &&
                  image.entity_id == selectedSiloImage.entity_id
              ),
              selectedSiloImage: selectedSiloImage,
            }}
          >
            <FlagSiloModal context_type={"project"} />
          </ProjectActionContext.Provider>
        )}

        {
          <Modal
            className="modal-space"
            destroyOnClose={true}
            width={700}
            visible={collaborationModal !== undefined}
            closable={false}
            bodyStyle={{ padding: 0 }}
            footer={[
              <span className="justify-in-end">
                <Button
                  disabled={isCollaborationButtonLoading}
                  style={{ textAlign: "center" }}
                  className="modal-okay-gray square font-12"
                  onClick={collaborateCloseConfirmModal}
                >
                  Cancel
                </Button>
                <Button
                  disabled={isCollaborationButtonLoading}
                  style={{ textAlign: "center" }}
                  className="modal-okay square font-12"
                  onClick={openCollaborateTool}
                >
                  {isCollaborationButtonLoading ? (
                    <span>
                      Please wait.. <LoadingOutlined spin />
                    </span>
                  ) : (
                    <span>Go to tool </span>
                  )}
                </Button>
              </span>,
            ]}
          >
            <div style={{ padding: 30, display: "flex" }}>
              <Col span={24}>
                <h2 className="modal-heading manrope f-14 black-00 w-600">
                  Go to collaborate tool?{" "}
                </h2>
                <p className="manrope f-12 black-33">
                  This tool will allow you to post any feedback you have for
                  this render.{" "}
                </p>
              </Col>
            </div>
          </Modal>
        }

        {
          <Modal
            destroyOnClose={true}
            className="modal-share-success"
            width={600}
            visible={deleteModal}
            closable={false}
            footer={[
              <span className="justify-in-center">
                <Button
                  style={{ textAlign: "center" }}
                  disabled={deleteLoader}
                  className="modal-okay-gray square font-14"
                  onClick={() => setDeleteModal(undefined)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ textAlign: "center" }}
                  disabled={deleteLoader}
                  className="modal-okay square font-14"
                  onClick={() => deleteImage()}
                >
                  {deleteLoader ? (
                    <span>
                      Deleting <LoadingOutlined spin />
                    </span>
                  ) : (
                    <span> Okay </span>
                  )}
                </Button>
              </span>,
            ]}
            centered={true}
          >
            <div
              style={{
                margin: "0px auto 0px auto",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <h2 className="manrope f-16 black-00 w-600">
                  You're about to delete{" "}
                  {deleteModal?.image_type == "lifestyle"
                    ? "a Lifestyle Image" :
                    deleteModal?.image_type == "ai" ? "an AI Image" :
                    deleteModal?.image_type == "ai_video" ? "a Video" :
                    "a Silo Image"}{" "}
                  
                </h2>
                <p className="manrope f-14 black-55">
                  This will remove your{" "}
                  {deleteModal?.image_type == "lifestyle"
                    ? "lifestyle image" : deleteModal?.image_type == "ai" ? "AI image"
                    : deleteModal?.image_type == "ai_video" ? "AI video"
                    : "silo image"}{" "}
                 . Are you sure you want to delete?
                </p>
              </div>
            </div>
          </Modal>
        }

        {
          <GenerateHighResModal
            confirmHighResModal={confirmHighResModal}
            setConfirmHighResModal={setConfirmHighResModal}
            renders={selectedSceneRenders}
            setModalVisible={setHighResModalVisible}
            modalVisible={highResModalVisible}
            selectedRender={selectedLifestyleRender}
          />
        }
        {
          <ComplaintModal
            selectedImgComplaint={selectedImgComplaint}
            setSelectedImgComplaint={setSelectedImgComplaint}
            complaintModal={complaintModal}
            setComplaintModal={setComplaintModal}
            renders={selectedSceneRenders}
            checkIfComplaintInProgress={checkIfComplaintInProgress}
            checkIfFlagIsDisabled={checkIfFlagIsDisabled}
          />
        }

        {
          <TwoDImagesModal
            isVisible={isModalVisible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            currentfile={selectedImage}
            filteredImages={filteredImages}
            renderDelete={renderDelete}
            renderDownload={renderDownload}
            renderGenerateHighResImage={renderGenerateHighResImage}
            setType={setImageType}
            Type={Type}
            imagesCount={imagesCount}
            renderCollaborationTooltip={renderCollaborationTooltip}
            renderReportButton={renderReportButton}
            renderFavouriteButton={renderFavouriteButton}
            updatedRenderNameInImagesList={updatedRenderNameInImagesList}
            markFavorite={markFavorite}
            unmarkFavorite={unmarkFavorite}
            handleSubmitForReview={handleSubmitForReview}
          />
        }

        <AIEditorModalViewer
          ai_page={true}
          isOpen={isAIModalOpen}
          onClose={handleAIModalClose}
          imageData={selectedAIImageData}
          compareSiloModalOpen={compareSiloModalOpen}
          setCompareSiloModalOpen={setCompareSiloModalOpen}
          goToNextImage={goToNextImage}
          goToPreviousImage={goToPreviousImage}
          imageDisplayLoader={imageDisplayLoader}
          renderDelete={renderDelete}
          updatedRenderNameInImagesList={updatedRenderNameInImagesList}
          markFavorite={handleMarkFav}
          unmarkFavorite={handleUnmarkFav}
          promptsLoading={promptsLoading}
          handleCollaborateAiImage={handleCollaborateAiImage}
          handleSubmitForReviewImageLibrary={handleSubmitForReview}
        />
        {isGenVideoModalOpen && videoGenImage && (
          <GenerateAiVideoModal
            visible={isGenVideoModalOpen}
            onCancel={() => {
              setIsGenVideoModalOpen(false);
            }}
            imageUrl={videoGenImage.thumbnail}
            image_id={videoGenImage.id}
            onSuccess={async () => {
              if (refetch) await refetch();
              if (setImageType) setImageType('ai_video');
            }}
          />
        )}
      </Col>
    </Row>
  );
};
export default TwoDImagesTabs;
